<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5>Mudar Senha</h5>
      </div>
      <div class="col-md-6 text-right" style="padding-top: 5px;">
        <i (click)="fecharModal()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <form [formGroup]="formMudarSenha" id="formMudarSenha">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="senhaAntiga">Senha Atual</label>
                <input type="password" id="senhaAntiga"
                       placeholder="Digite sua senha atual"
                       [ngClass]="{'is-invalid': formMudarSenha.get('senhaAntiga')?.errors}"
                       formControlName="senhaAntiga" class="form-control">
                <span id="senhaAntiga-error-required" class="error mensagem-erro"
                      *ngIf="formMudarSenha.get('senhaAntiga')?.dirty &&
                          formMudarSenha.get('senhaAntiga')?.errors?.required"
                >A senha atual é obrigatória <br></span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="novaSenha">Nova Senha</label>
                <input type="password" id="novaSenha"
                       placeholder="Digite sua nova senha"
                       [ngClass]="{'is-invalid': formMudarSenha.get('novaSenha')?.errors}"
                       formControlName="novaSenha" class="form-control">
                <span id="novaSenha-error-required" class="error mensagem-erro"
                      *ngIf="formMudarSenha.get('novaSenha')?.dirty &&
                          formMudarSenha.get('novaSenha')?.errors?.required"
                >A nova senha é obrigatória <br></span>
                <span id="novaSenha-error-minlength" class="error mensagem-erro"
                      *ngIf="formMudarSenha.get('novaSenha')?.touched &&
                          formMudarSenha.get('novaSenha')?.errors?.minlength"
                >A nova senha deve ter pelo menos 6 caracteres <br></span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="confirmacaoSenha">Confirmar Nova Senha</label>
                <input type="password" id="confirmacaoSenha"
                       placeholder="Confirme sua nova senha"
                       [ngClass]="{'is-invalid': formMudarSenha.get('confirmacaoSenha')?.errors}"
                       formControlName="confirmacaoSenha" class="form-control">
                <span id="confirmacaoSenha-error-required" class="error mensagem-erro"
                      *ngIf="formMudarSenha.get('confirmacaoSenha')?.dirty &&
                          formMudarSenha.get('confirmacaoSenha')?.errors?.required"
                >A confirmação da senha é obrigatória <br></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6" style="padding-top: 10px;margin-top: 20px;">
              <button class="btn btn-warning" (click)="fecharModal()">Cancelar</button>
            </div>
            <div class="col-md-6 pull-right text-right" style="padding-top: 10px;margin-top: 20px;">
              <button class="btn btn-primary" (click)="salvar()">Salvar</button>
            </div>
          </div>
      </form>
    </div>
  </div>
</div>
